module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-03.f8ea6a26.png";